export enum CLIENT_TAB_VALUES {
  INFO = 'info',
  PAYMENT = 'payment',
  HISTORY = 'history',
  ACTIVITY = 'activity',
}

export const PHONE_ERROR = 'Длина должна быть 11 или 12 символов';
export const PHONE_REGEX = /^[0-9]{11,12}$/;
export const PHONE_LEADING_SEVEN_ERROR = 'Номер телефона должен начинаться с 7 или 8';
export const PHONE_LEADING_SEVEN_REGEX = /^[7|8].*/;

export const PHONE_OR_EMAIL_ERROR = 'Укажите почту или номер телефона';
